<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <form
        accept-charset="utf-8"
        id="login"
        role="form"
        v-on:submit="withdraw($event)"
      >
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <h5>
              <i class="fas fa-vote-yea"></i> แจ้งถอนเงิน
            </h5>
          </b-col>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row>
          <b-col>
            <label id="labelselectbank" v-if="!transfered">
              <i class="fas fa-university"></i>
              เลือกบัญชีธนาคารของท่าน
              <br />
              <small>
                <font color="red">*กรุณากดคลิกบัญชีด้านล่างตามที่ท่านต้องการ</font>
              </small>
            </label>
          </b-col>
        </b-row>
        <b-row>
          <div
            class="col-6 col-sm-6 col-md-3 col-lg-2 mt-2 text-center"
            v-for="item in userBanks"
            v-bind:key="item.id"
          >
            <label :for="item.id" class="bank-radio w-100" @click="bankSelected = item.id" v-if="item.bankID != 0">
              <div 
                class="bank-logo p-3 rounded rounded-lg"
                :style="(bankSelected !== undefined && bankSelected == item.id) ? {background: banks[banks.findIndex(x => x.bankID == item.bankID)].color, boxShadow: '0 0 3px 3px ' + banks[banks.findIndex(x => x.bankID == item.bankID)].color} : {background: banks[banks.findIndex(x => x.bankID == item.bankID)].color}"
              >
                <img :src="banks[banks.findIndex(x => x.bankID == item.bankID)].logo" alt="Bank Logo" class="icon-bank bnk48_004" />
              </div>
              <div
                :style="(bankSelected !== undefined && bankSelected == item.id) ? {background: banks[banks.findIndex(x => x.bankID == item.bankID)].color} : []"
                :class="(bankSelected !== undefined && bankSelected == item.id) ?  'p-1 rounded-bottom text-right' : 'p-1 rounded rounded-lg'"
              >
                <span
                  :class="(bankSelected !== undefined && bankSelected == item.id) ?  'text-white font-weight-bold' : ''"
                >{{banks[banks.findIndex(x => x.bankID == item.bankID)].title}}</span>
                <b-badge
                  variant="dark"
                  :class="(bankSelected !== undefined && bankSelected == item.id) ?  'font-weight-bold w-100 text-right' : 'font-weight-bold w-100'"
                >{{item.accountNo}}</b-badge>
                <div
                  class="check-icon rounded-circle text-white"
                  v-if="(bankSelected !== undefined && bankSelected == item.id)"
                  :style="{background: banks[banks.findIndex(x => x.bankID == item.bankID)].color}"
                >
                  <i class="fas fa-check-circle fa-md"></i>
                </div>
              </div>
            </label>
          </div>
        </b-row>
        <div class="w-100 mt-2 mb-3 border-bottom"></div>
        <b-row>
          <b-col cols="12" sm="12" md="6">
            <label>
              <i class="fas fa-coins"></i> จำนวนเงินที่ถอนได้
            </label>
            <b-form-input
              size="lg"
              :value="profile.cashAmount ? profile.cashAmount.toFixed(2) + ' ฿' : '0.00 ฿'"
              class="text-center text-success font-weight-bold credit-balance"
              readonly
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="12" md="6">
            <label>
              <i class="fas fa-hand-holding-usd"></i> จำนวนเงินที่ต้องการถอน
            </label>
            <b-input-group prepend="฿" size="lg">
              <b-form-input min="100" :max="profile.cashAmount" v-model="withdrawAmount"></b-form-input>
              <b-input-group-append>
                <b-button variant="warning" @click="withdrawAmount = profile.cashAmount">ทั้งหมด</b-button>
              </b-input-group-append>
            </b-input-group>
            <small class="text-secondary">ถอนเงินขั้นต่ำ 100 หรือ สูงสุด 200,000 บาท</small>
          </b-col>
          <b-col cols="12">
            <label>
              <i class="far fa-star"></i> หมายเหตุ
            </label>
            <b-form-textarea v-model="notes"></b-form-textarea>
          </b-col>
        </b-row>
        <!-- <b-row v-if="errMessage" class="mt-3">
          <b-col>
            <b-alert show variant="danger" class="mb-0">{{errMessage}}</b-alert>
          </b-col>
        </b-row> -->
        <b-row v-if="errMessage" class="mt-3">
          <b-col>
            <b-alert show variant="danger" class="mb-0">{{errMessage}}</b-alert>
          </b-col>
        </b-row>
        <div class="w-100 mt-3 mb-3 border-bottom"></div>
        <b-row>
          <b-col>
            <b-button variant="secondary" block>ยกเลิก</b-button>
          </b-col>
          <b-col>
            <b-button variant="success" block type="submit">ถอนเงิน</b-button>
          </b-col>
        </b-row>
      </b-card>
      </form>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: "Withdraw",
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      profile: [],
      withdrawAmount: 0,
      bankSelected: null,
      userBanks: [],
      notes: null,
      errMessage: null,
      banks: [
        {
          bankID: 1,
          code: "BBL",
          title: "กรุงเทพ",
          logo: require('../../assets/images/bank-icon/bbl.svg'),
          color: "#1e4598"
        },
        {
          bankID: 2,
          code: "KBANK",
          title: "กสิกรไทย",
          logo: require('../../assets/images/bank-icon/kbank.svg'),
          color: "#138f2d"
        },
        {
          bankID: 3,
          code: "KTB",
          title: "กรุงไทย",
          logo: require('../../assets/images/bank-icon/ktb.svg'),
          color: "#1ba5e1"
        },
        {
          bankID: 4,
          code: "SCB",
          title: "ไทยพาณิชย์",
          logo: require('../../assets/images/bank-icon/scb.svg'),
          color: "#4e2e7f"
        },
        {
          bankID: 5,
          code: "BAY",
          title: "กรุงศรีอยุธยา",
          logo: require('../../assets/images/bank-icon/bay.svg'),
          color: "#fec43b"
        },
        {
          bankID: 6,
          code: "CIMB",
          title: "ซีไอเอ็มบี",
          logo: require('../../assets/images/bank-icon/cimb.svg'),
          color: "#7e2f36"
        },
        {
          bankID: 7,
          code: "GSB",
          title: "ออมสิน",
          logo: require('../../assets/images/bank-icon/gsb.svg'),
          color: "#eb198d"
        },
        {
          bankID: 8,
          code: "KIATNAKIN",
          title: "เกียรตินาคิน",
          logo: require('../../assets/images/bank-icon/kk.svg'),
          color: "#199cc5"
        },
        {
          bankID: 9,
          code: "LHBANK",
          title: "แลนด์ แอนด์ เฮาส์",
          logo: require('../../assets/images/bank-icon/lhb.svg'),
          color: "#6d6e71"
        },
        {
          bankID: 10,
          code: "STANDARD",
          title: "สแตนดาร์ดชาร์เตอร์ด (ไทย)",
          logo: require('../../assets/images/bank-icon/sc.svg'),
          color: "#0f6ea1"
        },
        {
          bankID: 11,
          code: "THANACHART",
          title: "ธนชาติ",
          logo: require('../../assets/images/bank-icon/tbnk.svg'),
          color: "#fc4f1f"
        },
        {
          bankID: 12,
          code: "TISCO",
          title: "ทิสโก้",
          logo: require('../../assets/images/bank-icon/tisco.svg'),
          color: "#12549f"
        },
        {
          bankID: 13,
          code: "TMB",
          title: "ทหารไทย",
          logo: require('../../assets/images/bank-icon/tmb.svg'),
          color: "#1279be"
        },
        {
          bankID: 14,
          code: "UOB",
          title: "ยูโอบี",
          logo: require('../../assets/images/bank-icon/uob.svg'),
          color: "#0b3979"
        }
      ],
      paymentSelected: [],
      paymentMethods: [
        {
          value: "ATM",
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          value: "CDM",
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          value: "CTC",
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          value: "INB",
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          value: "MBB",
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ],
      transfered: false
    };
  },
  mounted() {
    this.getProfile();
    // console.log('bank index', this.banks[this.banks.findIndex(x => x.bankID === 5)].color);
  },
  methods: {
    withdraw(e) {
      e.preventDefault();
      this.errMessage = null;
      axios
        .post(
          this.getApiUrl + "/cash/addcashtransfer",
          {
            username: this.getUsername,
            transferType: 2,
            amount: this.withdrawAmount,
            bankAccountID: this.bankSelected,
            detail: this.notes
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          console.log(response.data.statusCode)
          if(response.data.statusCode != 200) {
            this.errMessage = response.data.message;
          }
          else {
            this.$router.push("/member/transaction");
          }
          console.log(response);
        });
    },
    getProfile() {
      axios
        .post(
          this.getApiUrl + "/customer/getcurrentfinance",
          {
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.profile = response.data.data;
          axios
            .post(
              this.getApiUrl + "/cash/getallBankAccount",
              {
                username: this.getUsername
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: this.getAccessToken,
                  username: this.getUsername
                }
              }
            )
            .then(response => {
              this.userBanks = response.data.data;
              console.log("User Banks", response);
            });
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.acc-name {
  line-height: 35px;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}

.input-hidden {
  position: absolute;
  left: -9999px;
}

.bank-logo {
  border: 1px solid #fff;
  img {
    width: 70px;
  }
}

.check-icon {
  position: absolute;
  bottom: 9px;
  left: 17px;
  border: 2px #fff solid;
  padding: 2px 4px 0px 5px;
}
</style>